export function dispatchEvent(eventName: string) {
    window.dispatchEvent(new Event(eventName));
}
